import Swiper from 'swiper'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

window.addEventListener('load', () => {
  const main = document.querySelector('main')
  if (!main || !main.classList.contains('top')) return

  document.querySelectorAll('.kv_slider.swiper').forEach((el) => {
    const wrapper = el.querySelector('.swiper-wrapper')
    if (!wrapper) return

    const count = wrapper.querySelectorAll('.swiper-slide').length
    const prevEl = el.querySelector('.swiper-button-prev')
    const nextEl = el.querySelector('.swiper-button-next')
    const pagEl = el.querySelector('.swiper-pagination')
    const btnWrap = el.querySelector('.btn_wrapper')

    // 1枚：UI隠してSwiperは未初期化（不要なcloneやバグを避ける）
    if (count <= 1) {
      if (btnWrap) btnWrap.style.display = 'none'
      if (pagEl) pagEl.style.display = 'none'
      return
    }

    // 2枚以上：初期化
    // 2枚のときも loop 有効でOK（Swiperがクローン生成して循環）
    const swiper = new Swiper(el, {
      modules: [Autoplay, Pagination, Navigation],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 80,
      speed: 600,
      centeredSlides: true,
      watchOverflow: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: pagEl ? { el: pagEl, clickable: true } : undefined,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      breakpoints: {
        768: {
          slidesPerView: 2.545,
        },
      },
    })
  })

  document.querySelectorAll('.recipe_popular.swiper').forEach((el) => {
    const wrapper = el.querySelector('.swiper-wrapper')
    if (!wrapper) return

    const count = wrapper.querySelectorAll('.swiper-slide').length
    const prevEl = el.querySelector('.swiper-button-prev')
    const nextEl = el.querySelector('.swiper-button-next')
    const pagEl = el.querySelector('.swiper-pagination')
    const btnWrap = el.querySelector('.btn_wrapper')

    // スライダーのインスタンスを保持
    let swiperInstance = null

    // ブレークポイント設定（768px以上では無効）
    const breakpoint = window.matchMedia('(max-width: 767px)')

    const enableSwiper = () => {
      if (swiperInstance || count <= 1) return // すでに初期化済みまたは1枚のみ

      if (btnWrap) btnWrap.style.display = ''
      if (pagEl) pagEl.style.display = ''

      swiperInstance = new Swiper(el, {
        modules: [Autoplay, Pagination, Navigation],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 80,
        autoHeight: true,
        speed: 600,
        centeredSlides: true,
        watchOverflow: true,
        pagination: pagEl ? { el: pagEl, clickable: true } : undefined,
        navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
        breakpoints: {
          768: {
            slidesPerView: 3,
          }
        },
      })
    }

    const disableSwiper = () => {
      if (!swiperInstance) return
      swiperInstance.destroy(true, true)
      swiperInstance = null

      // スタイルやクローンを整理（Swiper破棄後に戻す）
      wrapper.removeAttribute('style')
      wrapper.querySelectorAll('.swiper-slide').forEach(slide => {
        slide.removeAttribute('style')
      })

      if (btnWrap) btnWrap.style.display = 'none'
      if (pagEl) pagEl.style.display = 'none'
    }

    // 初回判定
    const checkBreakpoint = () => {
      if (breakpoint.matches) {
        enableSwiper()
      } else {
        disableSwiper()
      }
    }

    breakpoint.addEventListener('change', checkBreakpoint)
    checkBreakpoint()
  })

  /**
   * Responsive Swiper for .recipe_popular
   * @type {MediaQueryList}
   */
  // document.querySelectorAll('.recipe_popular.swiper').forEach((el) => {
  //   const breakpoint = window.matchMedia('(max-width: 798px)')
  //   let swiperInstance = null
  //
  //   const pagination = el.querySelector('.swiper-pagination')
  //   const prevEl = el.querySelector('.swiper-button-prev')
  //   const nextEl = el.querySelector('.swiper-button-next')
  //
  //   function enableSwiper() {
  //     if (swiperInstance) return // すでに初期化済みならスキップ
  //
  //     swiperInstance = new Swiper(el, {
  //       slidesPerView: 1,
  //       spaceBetween: 16,
  //       loop: false,
  //       pagination: {
  //         el: pagination,
  //         clickable: true,
  //       },
  //       navigation: {
  //         prevEl,
  //         nextEl,
  //       },
  //     })
  //     el.classList.add('is-swiper-active')
  //   }
  //
  //   function disableSwiper() {
  //     if (swiperInstance) {
  //       swiperInstance.destroy(true, true)
  //       swiperInstance = null
  //     }
  //     el.classList.remove('is-swiper-active')
  //   }
  //
  //   function checkBreakpoint(e) {
  //     if (e.matches) {
  //       enableSwiper()
  //     } else {
  //       disableSwiper()
  //     }
  //   }
  //
  //   // 初回チェック
  //   checkBreakpoint(breakpoint)
  //
  //   // 画面幅の変化を監視
  //   if (breakpoint.addEventListener) {
  //     breakpoint.addEventListener('change', checkBreakpoint)
  //   } else {
  //     breakpoint.addListener(checkBreakpoint)
  //   }
  // })
})
